import styled from 'styled-components';

export const InviteForm = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]};
  align-items: flex-end;
  flex-wrap: wrap;

  .invite-email-group {
    min-width: 280px;
    flex: 1;
  }

  .invite-role-group {
    min-width: 140px;
  }
`;

export const MemberAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
`;

export const MemberAvatarFallback = styled.div<{ $color?: string }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ theme, $color }) => $color ?? theme.colors.secondary};
  color: ${({ theme }) => theme.colors.textInverse};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const MemberRoleSelect = styled.div`
  .form-select {
    width: auto;
  }
`;

export const IntegrationCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing[4]};

  h3 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: ${({ theme }) => theme.fontSizes.lg};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    color: ${({ theme }) => theme.colors.primary};
    margin: 0 0 ${({ theme }) => theme.spacing[1]};
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[2]};
  }

  p {
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: ${({ theme }) => theme.fontSizes.sm};
    margin: 0;
  }
`;
